import React, {ReactNode} from 'react';

interface RevolveProps {
    /**
     * Angle by which the children will be revolved, measured in radians.
     */
    angle?: number;
    /**
     * Distance the children will appear from the origin
     */
    offset?: number;
    /**
     * Items to be revolved
     */
    children: ReactNode;
}
/**
 * Revolves its children around its center
 */
const Revolve = ({ angle, offset, children }: RevolveProps) => {
    const deg = angle * 180 / Math.PI;
    const outerTransform =
        `rotate(${deg}) translate(${offset} 0) rotate(${-deg})`;
    return <g className="svg-revolve" transform={outerTransform}>
        {children}
    </g>;
};

export default Revolve;
